import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const GroupByFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.checkIns.filters.group_by);
  const selectedFilters = useSelector((state) => state.checkIns.selectedFilters.group_by);

  return (
    <div className="group-by-filter">
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        placeholder="Select Group by"
        numberDisplayed={0}
        onSelectChange={(data) => dispatch(actionCreators.updateGroupBy(data))}
      />
    </div>
  );
};

export default GroupByFilter;
